export const CACHE_EXPIRY_TIME = 2 * 60 * 1000

export const cacheInitialState = {
  availableIds: [],
  data: {},
}

const MAX_CACHE_SIZE = 5

// don't cache empty transciptions as they may become available
const shouldCache = data => data.texts && data.texts.length > 0

export const cacheEntry = (cache, entry) => {
  const result = { ...cache }
  if (shouldCache(entry)) {
    result.availableIds.push(entry.ccrId)
    result.data[entry.ccrId] = { ...entry }
  }
  if (result.availableIds.length > MAX_CACHE_SIZE) {
    delete result.data[result.availableIds[0]]
    result.availableIds = result.availableIds.slice(1)
  }
  return result
}

export const getCachedEntry = (cache, ccrid) => {
  const isCached = cache.availableIds.some(id => id === ccrid)
  return isCached ? cache.data[ccrid] : null
}

export const removeCachedEntry = (cache, ccrid) => {
  const data = { ...cache.data }
  delete data[ccrid]
  return {
    availableIds: cache.availableIds.filter(id => id !== ccrid),
    data,
  }
}
